import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from 'next-i18next';

import { wrapper } from '@store/store';
import { fetchProducts } from '@thunks/products';

import AllProducts from '@routes/AllProducts';

import { prepareProductsRequestParams } from '@utils/filters';
import { getLocaleFromContext } from '@utils/getLocaleFromContext';

import { PRODUCTS_NEW } from '@common/routes.mjs';

const NewProductsPage = () => {
  const { t } = useTranslation();

  return (
    <AllProducts
      publishedOnly
      newArrivalOnly
      metaTitle={t('allProducts.metaTitle', 'Neuheiten')}
      pageTitle={t('allProducts.allTitle', 'Neuheiten')}
      pageUrl={PRODUCTS_NEW}
    />
  );
};

export const getServerSideProps = wrapper.getServerSideProps(
  store => async context => {
    const productsParams = prepareProductsRequestParams(context.query, {
      newArrivalOnly: true,
      publishedOnly: true,
    });

    await store.dispatch(fetchProducts(productsParams));

    return {
      props: {
        ...(await serverSideTranslations(getLocaleFromContext(context))),
      },
    };
  },
);

export default NewProductsPage;
